import React from "react";
import "./contact.css";
import CTAButton from "../../ui/CTAButton";
import PopupFormModal from "../popup-form/PopupForm";
import { useContactSection } from "../../hooks/useContactSection";
import { FaSpinner } from "react-icons/fa";

const ContactSection = () => {
  const { contactSectionData, isLoading, error } = useContactSection();

  if (isLoading) {
    return (
      <div className="loading-container">
        <FaSpinner
          className="spinner"
          style={{ animation: "spin 1s linear infinite" }}
        />
        <p>Loading contact section...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>Error loading contact section. Please try again later.</p>
      </div>
    );
  }

  return (
    <section className="contactSection">
      <div className="container">
        <div className="txtContent">
          <div className="header">
            <h2>{contactSectionData?.title || "Contact Us"}</h2>
          </div>
          <p>{contactSectionData?.description}</p>
          <div className="d-flex">
            <PopupFormModal
              triggerElement={
                <CTAButton link="#" text="Get Started" specialClass="blueBkg" />
              }
            />
            <CTAButton
              link="/booking"
              text="Book Now"
              specialClass="whiteBkg ml-3"
              blank={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
